var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconHelp = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0zM2.77 12a9.23 9.23 0 1 1 18.46 0 9.23 9.23 0 0 1-18.46 0zm6.122-3.27a2.023 2.023 0 0 1 1.904-1.345h2.102a2.275 2.275 0 0 1 1.132 4.25l-1.165.668a.867.867 0 0 1-.865.85.863.863 0 0 1-.865-.865v-.486c0-.31.165-.595.436-.75l1.597-.916a.545.545 0 0 0-.27-1.017h-2.102a.284.284 0 0 0-.27.191l-.015.043a.865.865 0 0 1-1.63-.577l.014-.043-.003-.003zm1.954 6.732a1.154 1.154 0 1 1 2.308 0 1.154 1.154 0 0 1-2.308 0z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-help.2e7bd9a1.svg";
export { ForwardRef as ReactComponent };